import Axios from "axios";
import {snakeKeysToCamel, camelKeysToSnake, pascalKeysToSnake} from "./format";
import {serialize} from "./url";

export interface HttpClientRequest {
  path: string;
  data?: any;
  config?: Record<string, any>;
  yourCaseFormat?: "camel" | "snake" | "pascal";
  theirCaseFormat?: "camel" | "snake" | "pascal";
}

export class HttpClient {
  baseUrl: string;
  yourCaseFormat: "camel" | "snake" | "pascal";
  theirCaseFormat: "camel" | "snake" | "pascal";
  //config: Record<string, any>;
  axiosInstance;

  constructor(
    baseUrl: string,
    yourCaseFormat: "camel" | "snake" | "pascal",
    theirCaseFormat: "camel" | "snake" | "pascal",
    config?: Record<string, any>,
  ) {
    this.baseUrl = baseUrl;
    this.yourCaseFormat = yourCaseFormat;
    this.theirCaseFormat = theirCaseFormat;
    // this.config = config || {
    //   headers: {
    //     "X-Requested-With": "XMLHttpRequest",
    //     "Origin": "https://app.localhost:8011",
    //     "Access-Control-Allow-Origin": "*",
    //   },
    // };
    this.axiosInstance = Axios.create({
      withCredentials: true, // Allow cookies to be sent with the request
      baseURL: this.baseUrl, // Replace with your API endpoint
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        //"Access-Control-Allow-Origin": "*",
      },
    });
  }

  get = async (options: HttpClientRequest) => {
    const {path, data = null, config, yourCaseFormat, theirCaseFormat} = options;
    try {
      const response = await this.axiosInstance.get(
        `${path}${serialize(
          this.formatRequest(data, yourCaseFormat || this.yourCaseFormat, theirCaseFormat || this.theirCaseFormat),
        )}`,
        config,
      );
      return this.formatResponse(
        response,
        yourCaseFormat || this.yourCaseFormat,
        theirCaseFormat || this.theirCaseFormat,
      );
    } catch (error: any) {
      throw this.formatResponse(
        error.response,
        yourCaseFormat || this.yourCaseFormat,
        theirCaseFormat || this.theirCaseFormat,
      );
    }
  };
  delete = async (options: HttpClientRequest) => {
    const {path, data = null, config, yourCaseFormat, theirCaseFormat} = options;
    try {
      const response = await this.axiosInstance.delete(`${path}`, config);
      return this.formatResponse(
        response,
        yourCaseFormat || this.yourCaseFormat,
        theirCaseFormat || this.theirCaseFormat,
      );
    } catch (error: any) {
      throw this.formatResponse(
        error.response,
        yourCaseFormat || this.yourCaseFormat,
        theirCaseFormat || this.theirCaseFormat,
      );
    }
  };
  head = async (options: HttpClientRequest) => {
    const {path, data = null, config, yourCaseFormat, theirCaseFormat} = options;
    try {
      const response = await this.axiosInstance.head(`${path}`, config);
      return this.formatResponse(
        response,
        yourCaseFormat || this.yourCaseFormat,
        theirCaseFormat || this.theirCaseFormat,
      );
    } catch (error: any) {
      throw this.formatResponse(
        error.response,
        yourCaseFormat || this.yourCaseFormat,
        theirCaseFormat || this.theirCaseFormat,
      );
    }
  };
  options = async (options: HttpClientRequest) => {
    const {path, data = null, config, yourCaseFormat, theirCaseFormat} = options;
    try {
      const response = await this.axiosInstance.options(`${path}`, config);
      return this.formatResponse(
        response,
        yourCaseFormat || this.yourCaseFormat,
        theirCaseFormat || this.theirCaseFormat,
      );
    } catch (error: any) {
      throw this.formatResponse(
        error.response,
        yourCaseFormat || this.yourCaseFormat,
        theirCaseFormat || this.theirCaseFormat,
      );
    }
  };
  post = async (options: HttpClientRequest) => {
    const {path, data = null, config, yourCaseFormat, theirCaseFormat} = options;
    try {
      const response = await this.axiosInstance.post(
        `${path}`,
        this.formatRequest(data, yourCaseFormat || this.yourCaseFormat, theirCaseFormat || this.theirCaseFormat),
        config,
      );
      return this.formatResponse(
        response,
        yourCaseFormat || this.yourCaseFormat,
        theirCaseFormat || this.theirCaseFormat,
      );
    } catch (error: any) {
      throw this.formatResponse(
        error.response,
        yourCaseFormat || this.yourCaseFormat,
        theirCaseFormat || this.theirCaseFormat,
      );
    }
  };
  put = async (options: HttpClientRequest) => {
    const {path, data = null, config, yourCaseFormat, theirCaseFormat} = options;
    try {
      const response = await this.axiosInstance.put(
        `${path}`,
        this.formatRequest(data, yourCaseFormat || this.yourCaseFormat, theirCaseFormat || this.theirCaseFormat),
        config,
      );
      return this.formatResponse(
        response,
        yourCaseFormat || this.yourCaseFormat,
        theirCaseFormat || this.theirCaseFormat,
      );
    } catch (error: any) {
      throw this.formatResponse(
        error.response,
        yourCaseFormat || this.yourCaseFormat,
        theirCaseFormat || this.theirCaseFormat,
      );
    }
  };
  patch = async (options: HttpClientRequest) => {
    const {path, data = null, config, yourCaseFormat, theirCaseFormat} = options;
    try {
      const response = await this.axiosInstance.patch(
        `${path}`,
        this.formatRequest(data, yourCaseFormat || this.yourCaseFormat, theirCaseFormat || this.theirCaseFormat),
        config,
      );
      return this.formatResponse(
        response,
        yourCaseFormat || this.yourCaseFormat,
        theirCaseFormat || this.theirCaseFormat,
      );
    } catch (error: any) {
      throw this.formatResponse(
        error.response,
        yourCaseFormat || this.yourCaseFormat,
        theirCaseFormat || this.theirCaseFormat,
      );
    }
  };

  private formatRequest = (
    data: any,
    yourCaseFormat: "camel" | "snake" | "pascal",
    theirCaseFormat: "camel" | "snake" | "pascal",
  ) => {
    if (yourCaseFormat === theirCaseFormat) {
      return data;
    } else if (yourCaseFormat === "camel") {
      if (theirCaseFormat === "snake") {
        return snakeKeysToCamel(data);
      } else if (theirCaseFormat === "pascal") {
        throw "Camel to pascal not implemented.";
      }
    } else if (yourCaseFormat === "snake") {
      if (theirCaseFormat === "camel") {
        return camelKeysToSnake(data);
      } else if (theirCaseFormat === "pascal") {
        throw "Snake to pascal not implemented.";
      }
    } else if (yourCaseFormat === "pascal") {
      if (theirCaseFormat === "snake") {
        return pascalKeysToSnake(data);
      } else if (theirCaseFormat === "camel") {
        throw "Pascal to camel not implemented.";
      }
    }
  };

  private formatResponse = (
    response: any,
    yourCaseFormat: "camel" | "snake" | "pascal",
    theirCaseFormat: "camel" | "snake" | "pascal",
  ) => {
    if (yourCaseFormat === theirCaseFormat) {
      return {status: response.status, data: response.data};
    } else if (theirCaseFormat === "camel") {
      if (yourCaseFormat === "snake") {
        return {status: response.status, data: snakeKeysToCamel(response.data)};
      } else if (yourCaseFormat === "pascal") {
        throw "Camel to pascal not implemented.";
      }
    } else if (theirCaseFormat === "snake") {
      if (yourCaseFormat === "camel") {
        return {status: response.status, data: camelKeysToSnake(response.data)};
      } else if (yourCaseFormat === "pascal") {
        throw "Snake to pascal not implemented.";
      }
    } else if (theirCaseFormat === "pascal") {
      if (yourCaseFormat === "snake") {
        return {status: response.status, data: pascalKeysToSnake(response.data)};
      } else if (yourCaseFormat === "camel") {
        throw "Pascal to camel not implemented.";
      }
    }
    throw "Response format not supported.";
  };
}
